export class LocalStorageKeys {
  static helisaCompanyKey: string = 'helisa-company';
  static helisaCompanyNameKey: string = 'helisa-company-name';
  static helisaCompanyIdentityKey: string = 'helisa-company-identity';
  static helisaCompanyBeginDateKey: string = 'helisa-company-begin-date';
  static helisaCompanyLocalCurrencyKey: string = 'helisa-local-currency';
  static helisaCompanyFunctionalCurrencyKey: string =
    'helisa-functional-currency';
  static helisaCurrentOption: string = 'helisa-current-option';
  static helisaLastOption: string = 'helisa-last-option';
  static authLicenseKey: string = 'helisa-license';
  static authModules = 'helisa-modules';
  static authPermissions = 'helisa-permissions';
  static refreshTokenKey = 'helisa-refresh-token';
  static credentialsKey = 'helisa-token';
  static accountingListKey: string = 'accounting-list';
  static fiscalConciliationListKey: string = 'fiscal-accounting-list';
  // TODO delete, se debe tomar del menu completo
  static helisaCompanyLocalCurrency: string = 'helisa-local-currency';
  static helisaCompanyFunctionalCurrency: string = 'helisa-functional-currency';
  static accountingClosingPeriod: string = 'accounting-closing-period';
  static helisaCompanyUseFiscalInfoKey: string =
    'helisa-company-use-fiscal-info';
  static helisaCompanyCountry = 'helisa-company-country';
  static helisaCostsCenter: string = 'helisa-costs-center';
  static helisaGrouperTypes: string = 'helisa-grouper-types';
  static helisaGrouperValues: string = 'helisa-grouper-values';
  static helisaBusinessClass: string = 'helisa-business-class';
  static helisaBusinessConcept: string = 'helisa-business-concept';
  static helisaBusiness: string = 'helisa-business';
  static helisaTaxConcepts: string = 'helisa-tax-concepts';
  static helisaUserInfo: string = 'helisa-user-info';
  static accountingMaxLevel: string = 'accounting-max-level';
  static configurationBusinessControlSate: string =
    'configuration-business-control-state';
  static userCompanyEstablishment: string = 'user-company-establishment';
  static userCompanyInitialEstablishment: string =
    'user-company-initial-establishment';
}
